import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function DialogErrMsg({ onClose, title, code, message }) {
    const { t } = useTranslation();
    return (
        <Dialog open fullWidth maxWidth="xs" onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Typography variant="subtitle1">Code: {code}</Typography>
                    <Typography variant="subtitle1">Message: {message}</Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {t('button.label.close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
